// import layout from '@/layout/layout.vue';
import './autoRouter';
export const LOGIN_PATH = '/login';

